/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const RECEIVE_LOCATION_SCHOOLS = '@@nzr/detail/RECEIVE_LOCATION_SCHOOLS' as const
